









































import Vue from "vue";
import { bus } from "@/utils/event-emitter";
import { DELETE_ORDER_DISH } from "@/queries/customer/mutation.graphql";
export default Vue.extend({
  props: {
    showRipple: {
      type: Boolean
    },
    gray: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    maxHeight: {
      type: [String],
      default: "auto"
    }
  },
  data() {
    return {
      openDeleteConfirmation: false,
      selectedItem: null
    };
  },
  methods: {
    edit(selected) {
      this.$store.commit("anonymousModule/changeDishItemModalState", true);
      bus.$emit("edit-order-dish", selected);
    },
    chooseForDelete(selected) {
      bus.$emit("selectedOrderDishForDelete", selected);
    }
  },
  computed: {
    price() {
      const obj = {};
      obj["total"] = 0;
      this.items.forEach((el: any) => {
        obj[el.id] = el.Dish.price;
        el.OrderDishModifierItems.forEach(element => {
          obj[el.id] += element.ModifierItem.price * element.count;
        });
        obj[el.id] = +(obj[el.id] * el.count).toFixed(2);
        obj["total"] += obj[el.id];
      });
      obj["total"] = +obj["total"].toFixed(2);
      this.$store.commit("customerModule/setTotaslPrice", obj["total"]);
      return obj;
    }
  }
});
